export const SET_WP_CATEGORY_LABELS = 'SET_CATEGORY_LABELS'; // 设置标签 -壁纸-分类
export const GET_WP_CATEGORY_LABELS = 'GET_CATEGORY_LABELS'; // 获取标签-壁纸-分类

export const SET_WP_CATEGORY_IMGINFO = 'SET_CATEGORY_IMGINFO'; // 设置下拉滚动图片列表信息 -壁纸-分类
export const GET_WP_CATEGORY_IMGINFO = 'GET_CATEGORY_IMGINFO'; // 获取下拉滚动图片列表信息-壁纸-分类

// 壁纸精选
export const SET_WP_BANNER_LIST = 'GET_BANNER_LIST'; // 获取精选壁纸banners信息
export const GET_WP_BANNER_LIST = 'UPDATE_BANNER_LIST';
export const SET_WP_RECOMMEND_LIST = 'SET_RECOMMEND_LIST'; // 获取精选壁纸每日推荐图片数据
export const GET_WP_RECOMMEND_LIST = 'UPDATE_RECOMMEND_LIST';
// 获取精选壁纸banners信息
export const GET_WP_RECO_BANNER = 'GET_WP_RECO_BANNER';
export const SET_WP_RECO_BANNER = 'SET_WP_RECO_BANNER';
// 获取精选壁纸group
export const GET_WP_RECO_GROUP = 'GET_WP_RECO_GROUP';
export const SET_WP_RECO_GROUP = 'SET_WP_RECO_GROUP';
// 获取精选壁纸Rank
export const GET_WP_RANK_MORE = 'GET_WP_RANK_MORE';
export const SET_WP_RANK_MORE = 'SET_WP_RANK_MORE';
// 获取壁纸详情页面banner
export const SET_WP_DETAIL_RECO_BANNER = 'SET_WP_DETAIL_RECO_BANNER';
export const GET_WP_DETAIL_RECO_BANNER = 'GET_WP_DETAIL_RECO_BANNER';

// 壁纸我的
export const SET_WP_MINE_LIST = 'SET_WP_MINE_LIST';
export const GET_WP_COLLECT_LIST = 'GET_WP_COLLECT_LIST';
export const GET_WP_SETUP_LIST = 'GET_WP_SETUP_LIST';
export const CANCEL_WP_MINE_COLLECTORSETUP = 'CANCEL_WP_MINE_COLLECTORSETUP';

// 壁纸操作
export const GET_WP_OPTERAYTION = 'GET_WP_OPTERAYTION'; // 获取壁纸
export const SET_WP_OPTERAYTION = 'SET_WP_OPTERAYTION'; // 设置壁纸
// 展示预览图
export const WP_UPDATE_PREVIEW = 'WP_UPDATE_PREVIEW';
// 锁屏壁纸
export const GET_WP_SCREEN_LIST = 'GET_WP_SCREEN_LIST';
export const SET_WP_SCREEN_LIST = 'SET_WP_SCREEN_LIST';

export const WP_ADD_DOWNLOAD_IMG = 'WP_ADD_DOWNLOAD_IMG';
export const WP_REMOVE_DOWNLOAD_IMG = 'WP_REMOVE_DOWNLOAD_IMG';
export const WP_UPDATE_STATUS_DOWNLOAD_IMG = 'WP_UPDATE_STATUS_DOWNLOAD_IMG';
export const WP_UPDATE_PROGRESS_DOWNLOAD_IMG = 'WP_UPDATE_PROGRESS_DOWNLOAD_IMG';

// 壁纸的下载状态
export const WP_DOWNLOAD_WAIT = 0; // 下载准备中
export const WP_DOWNLOAD_ING = 1; // 下载中
export const WP_DOWNLOAD_FINISHED = 2; // 下载完成
export const WP_DOWNLOAD_FAILED = 3; // 下载失败
export const WP_SET_ING = 4; // 设置中
export const WP_SET_FINISHED = 5; // 设置成功
export const WP_SET_FAILED = 6; // 设置失败
export const WP_DOWNLOAD_CANCELED = 7; // 取消下载

// 壁纸全部作家列表
export const GET_WP_AUTHOR_LIST = 'GET_WP_AUTHOR_LIST';
export const SET_WP_AUTHOR_LIST = 'SET_WP_AUTHOR_LIST';
// 壁纸 作家详情
export const GET_WP_AUTHOR_DETAIL = 'GET_WP_AUTHOR_DETAIL';
// 壁纸 作家作品集
export const GET_WP_AUTHOR_SHOWREEL = 'GET_WP_AUTHOR_SHOWREEL';
export const SET_WP_AUTHOR_SHOWREEL = 'SET_WP_AUTHOR_SHOWREEL';
export const SET_WP_CATEGORY_STATUS = 'SET_WP_CATEGORY_STATUS';
// 壁纸位置
export const SET_SCROLL = 'SET_SCROLL';
